export { default as Home } from './Home';
export { default as Register } from './Register';
export { default as Reset } from './Reset';
export { default as Login } from './Login';
export { default as Forgot } from './Forgot';
export { default as Write } from './Write';
export { default as Post } from './Post';
export { default as Product } from './Product';
export { default as Banner } from './Banner';
export { default as Brand } from './Brand';
export { default as Event } from './Event';
export { default as Letter } from './Letter';
export { default as Quote } from './Quote';
export { default as Partner } from './Partner';
export { default as OrderList } from './OrderList';
export { default as OrderDetail } from './OrderDetail';
export { default as OrderInvoice } from './OrderInvoice';
export { default as OrderOffer } from './OrderOffer';
export { default as OrderTax } from './OrderTax';
export { default as OrderRefund } from './OrderRefund';
export { default as Checkout } from './Checkout';
export { default as CheckoutSuccess } from './CheckoutSuccess';
export { default as CheckoutFail } from './CheckoutFail';
export { default as Offer } from './Offer';
export { default as Cart } from './Cart';
export { default as Wish } from './Wish';
export { default as User } from './User';
export { default as Saves } from './Saves';
export { default as Settings } from './Settings';
export { default as Estimate } from './Estimate';
export { default as EstimateBox } from './EstimateBox';
export { default as Policy } from './Policy';
export { default as About } from './About';
export { default as NotFound } from './errors/NotFound';
export { default as Forbidden } from './errors/Forbidden';
export { default as Success } from './Success';
export { default as Search } from './Search';
export { default as Series } from './Series';



// WEBPACK FOOTER //
// ./src/pages/index.js